import type { CSSProperties } from "react";

export interface SwooshSweepProps {
  /** Extra classes for the SVG (e.g. `size-full` to fill and crop the parent). */
  className?: string;
  /** Inline styles — typically `width`/`translate` for the full-viewport background, or `color`. */
  style?: CSSProperties;
}

/**
 * Bare dramatic two-curve swoosh SVG. Strokes in `currentColor` so callers set the tint via a
 * text-color class. Keeps the default `xMidYMid meet` aspect handling so the whole sweep stays
 * visible when fitted into a box (the full-bleed background sizes the box to the viewBox ratio,
 * so this is a no-op there). Decorative — parents own positioning, sizing, overflow, z-ordering.
 */
export function SwooshSweep({ className, style }: SwooshSweepProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      role="none"
      style={style}
      viewBox="0 0 2411.56 1219.35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57.1986 703.644C187.417 663.504 492.715 789.396 657.109 797.477C798.278 804.416 1002.32 763.041 1016.5 481.956C1030.68 200.871 671.532 273.412 639.214 7.23176"
        stroke="currentColor"
        strokeWidth={120}
      />
      <path
        d="M2193.71 1209.62C2163.13 1023.54 1938.23 1121.98 1879.32 952.25C1845.82 875.021 1848.12 672.488 2063.81 647.399"
        stroke="currentColor"
        strokeWidth={120}
      />
    </svg>
  );
}
